// src/utils/slugify.js
export const createSlug = (title) => title.toLowerCase().replace(/\s+/g, "-");
